import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { capturePageview } from './posthog';

/**
 * Dispara um `$pageview` no PostHog a cada mudança de rota (SPA).
 * No-op quando o PostHog está desligado (sem `VITE_POSTHOG_KEY`).
 * Deve ser chamado dentro do Router.
 */
export function usePosthogPageviews(): void {
  const location = useLocation();
  const lastPath = useRef<string | null>(null);

  useEffect(() => {
    const path = `${location.pathname}${location.search}`;
    if (lastPath.current === path) return;
    lastPath.current = path;
    capturePageview(location.pathname);
  }, [location.pathname, location.search]);
}

export default usePosthogPageviews;
